<script>
export default {
    name: 'EncryptInput',
    props: {
        value: {
            type: String,
            default: ''
        },
        rule: {
            type: String,
            default: ''
        },
        word: {
            type: Number,
            default: 4
        },
        // 是否可编辑
        editable: {
            type: Boolean,
            default: true
        },
        toggleable: {
            type: Boolean,
            default: true
        },
        // 脱敏规则：保留前几位
        // keepPrefix: {
        //     type: Number,
        //     default: 4
        // },
        // 脱敏规则：保留后几位
        // keepSuffix: {
        //     type: Number,
        //     default: 4
        // },
        // 脱敏符号
        maskChar: {
            type: String,
            default: '*'
        },
        // 初始状态是否显示原文
        showByDefault: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showOriginal: this.showByDefault,
            isEditing: false,
            tempValue: this.value
        }
    },
    computed: {
        // 显示的值（根据状态返回原始值或脱敏值）
        displayValue() {
            if (this.showOriginal || !this.toggleable) {
                return this.value
            }
            return this.getMaskedValue(this.value)
        }
    },
    watch: {
        value(newVal) {
            this.tempValue = newVal
        }
    },
    methods: {
        // 获取脱敏后的值
        getMaskedValue(value) {
            const valueLenth = value.length
            if(this.rule === 'center') {
                const showLength = Math.floor((valueLenth - this.word) / 2)
                this.keepPrefix = showLength
                this.keepSuffix = showLength
            } else if (this.rule === 'front') {
                this.keepPrefix = 0
                const keepSuffix = valueLenth - this.word
                this.keepSuffix = keepSuffix
            } else if (this.rule === 'after') {
                const keepPrefix = valueLenth - this.word
                this.keepPrefix = keepPrefix
                this.keepSuffix = 0
            }
            if (!value || valueLenth <= this.keepPrefix + this.keepSuffix) {
                return value
            }

            const prefix = value.substring(0, this.keepPrefix)
            const suffix = value.substring(value.length - this.keepSuffix)
            const maskLength = value.length - this.keepPrefix - this.keepSuffix
            const mask = this.maskChar.repeat(maskLength)
            
            return prefix + mask + suffix
        },
        // 点击事件处理
        handleClick() {
            if (this.editable) {
                this.isEditing = true
                this.$nextTick(() => {
                    this.$refs.input.focus()
                })
            } else if (this.toggleable) {
                this.showOriginal = !this.showOriginal
            }
        },
         // 输入框失去焦点处理
        handleBlur() {
            this.isEditing = false
            if (this.tempValue !== this.value) {
                this.$emit('input', this.tempValue)
            }
        }
    },
    render()  {
        return (
            <div class="secure-input">
                {
                    this.isEditing ? (
                        <el-input ref="input" v-model={this.tempValue} onBlur={this.handleBlur}></el-input>
                    ): <div class="secure-display" onClick={this.handleClick}>
                        <span class="secure-text">{ this.displayValue }</span>
                        <el-tooltip effect="dark" content="点击显示/隐藏" placement="top">
                            <i class={['secure-icon', this.showOriginal ? 'el-icon-view' : 'el-icon-lock']}></i>
                        </el-tooltip>
                    </div>
                }
            </div>
        )
    }
}
</script>
<style scoped>
.secure-input {
  position: relative;
}

.secure-display {
  display: inline-flex;
  align-items: center;
  padding: 0 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  background-color: #F5F7FA;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}

.secure-display:hover {
  border-color: #C0C4CC;
}

.secure-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.secure-icon {
  margin-left: 10px;
  color: #909399;
  font-size: 16px;
}
</style>